var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-0 container-posts"},[(_vm.isLoadingPosts)?_c('progress-circular'):_vm._l((_vm.channel.posts),function(post){return _c('post-item',{key:post.id,staticClass:"mb-3",attrs:{"post":post}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }